import React, { useEffect, useState } from "react";
import topFlowerImg from "../../assets/images/svg/top_flower.svg";
import bottomFlowerImg from "../../assets/images/svg/bottom_flower.svg";
import greatSoulImg from "../../assets/images/the-great-souls/png/temple_the_great_souls.png";
import greatDecorate from "../../assets/images/coursesPage/LordGaveBapu/png/bapuBgDecorate.png";
import orangeTick from "../../assets/images/svg/orenge_tick.svg";
import Button from "../common/button/Button";
import CommonHeading from "../common/heading/CommonHeading";
import { ModalList } from "../../utils/TheGreateSageHelper";
import Modal from "../common/modal/Modal";
import { greateSageList } from "../../utils/TheGreateSageHelper";
const TheGreatSage = () => {
  const [popupOpen, setPopupOpen] = useState(null);

  function showPopup(index) {
    setPopupOpen(popupOpen === index ? null : index);
  }

  const isModalOpen = popupOpen !== null;
  useEffect(() => {
    if (isModalOpen) {
      document.getElementById("html").classList.add("overflow-hidden");
    } else {
      document.getElementById("html").classList.remove("overflow-hidden");
    }

    // Cleanup on component unmount
    return () => {
      document.getElementById("html").classList.remove("overflow-hidden");
    };
  }, [isModalOpen]);
  return (
    <>
      <div className="position-relative great_souls pt-2">
        {/*<img
          className="position-absolute bottom_flower_mahamantra end-0 maharaj_top z_index_n2"
          src={bottomFlowerImg}
          alt="bottom_flower"
        />*/} 
        <img
          src={greatSoulImg}
          className="w-25 position-absolute start-0"
          style={{ bottom: "-10%" }}
          alt="temple_the_great_souls"
        />
        <img
          src={greatDecorate}
          className="bapuBgDecorate position-absolute start-0 d-none d-sm-block"
          alt="bapuBgDecorate"
        />
        <img
          src={greatDecorate}
          className="bapuBgDecorate position-absolute end-0 d-none d-sm-block"
          alt="bapuBgDecorate"
        />
        {/*<img
          className="position-absolute top_flower_mahamantra souls_top_flower start-0 the_great_flower"
          src={topFlowerImg}
          alt="top_flower"
        />*/}

        <div className="container_modified container position-relative mt-0 pt-3 pt-sm-4">
          <div className="row justify-content-center mt-xl-2">
            <div className="col-lg-11 text-center mb-4 pb-lg-2">
              <CommonHeading
                heading="About"
                className="text-orange common_heading_text common_heading_text_brown"
              />
              <h2 className="common_sub_heading text-center mb-1 mb-md-3 px-4 px-md-0">
                MAHAMANTRA
              </h2>
            </div>
          </div>
          <div className="row justify-content-between mb-3 pb-3">
            <div className="col-lg-12">
              <div className="d-flex gap-2 mb-md-3 mb-2">
                <img src={orangeTick} className="mb-auto mt-1" alt="tick" />
                <p className="common_para lh_25 mb-0 pe-xl-5">
                  It has already been described earlier as to how Poojya Bapusbri received this mantra from Lord Sadguru Dattatreya and all Siddhas and Saints. Sadguru Himself has assented that all the chanters and singers of the dhun of this mantra for 5-7 minutes will be elevated to the meditative stage spontaneously after sitting down quietly with eyes closed and will enjoy mental peace during that state. There is nothing else required in this technique and that is the reason it is known as the ‘Technique of Spontaneous Meditation’.
                </p>
              </div>
              <div className="d-flex gap-2 mb-md-3 mb-2">
                <img src={orangeTick} className="mb-auto mt-1" alt="tick" />
                <p className="common_para lh_25 mb-0 pe-xl-4">
                  Verbatim meaning of this mantra is that ‘Only Brahma, Who is full of knowledge and is omnipresent like indivisible sky, is true and eternal; That Brahma leads from darkness to light and enables the realization of the Self after providing fundamental knowledge.’ This mantra is dedicated to omnipresent absolute Brahma and is not connected with any religion or sect i.e. it is non-sectarian and also all-sectarian.  
                </p>
              </div>
              <div className="d-flex gap-2 mb-md-3 mb-2">
                <img src={orangeTick} className="mb-auto mt-1" alt="tick" />
                <p className="common_para lh_25 mb-0 pe-xl-4">
                  Therefore its japa or chanting can be carried out by the people adhering to all religions and sects viz. Hindu, Muslim, Jain, Sikh, Parsi, Christian etc. and in fact it is being done so. From absolute point of view, japa of this mantra opens the passage to spiritual field. After all, this mantra has been offered by Sadguru. You know it well that the inception into the spiritual field is not possible without the grace of Sadguru and that is why it is said ‘Guru Kripa Hi Kevalam, Shishyasya Param Mangalam’ i.e. grace of Guru is most auspicious for the disciple. Detailed knowledge about the mantra is available in the literature published by the Ashram.
                </p>
              </div>
              <div className="d-flex gap-2 mb-md-3 mb-2">
                <img src={orangeTick} className="mb-auto mt-1" alt="tick" />
                <p className="common_para lh_25 mb-0 pe-xl-3">
                You will be pleased to know that no rituals are required for beginning the japa of this universally benedictory mahamantra. If you have a picture of Sadguru Dattatreya easily available, it may be placed at the proper place and then the japa or chanting of this mantra may be carried out. You will be glad to know that you don’t need to renounce sadhana-upasana of your Ishta or change your Guru or Guru-Mantra. As a matter of fact, this has been the experience of thousands of sadhakas that if the japa of Guru (Ishta) mantra is carried out in the beginning and concluding the same with the japa of this Mahamantra, fructification of Guru (Ishta) mantra is easier and quicker. According to the availability of time you may initially do 3, 11 or 26 malas japa of the mantra ‘Hari Om Tatsat Jai Guru Datta’, regular japa of Guru mantra may then be carried out in the required number and finally japa of the mantra ‘Hari Om Tatsat Jai Guru Daft& may be carried out in the same number as earlier.
                </p>
              </div>
              <div className="d-flex gap-2 mb-md-3 mb-2">
                <img src={orangeTick} className="mb-auto mt-1" alt="tick" />
                <p className="common_para lh_25 mb-0 pe-xl-4">
                  Effects of the japa of this mantra cannot be described but these can be experienced. Effects of the japa of this mantra in the field of spiritualism are being experienced even today. Thousands of people have even acquired desired material in the mundane field after canying out 2-4 purashcharana japa of this mantra; one purashcharana japa is said to be completed after carrying out 52 rnalas japa everyday for 52 days continuously.
                </p>
              </div>
              <div className="d-flex gap-2 mb-md-3 mb-2">
                <img src={orangeTick} className="mb-auto mt-1" alt="tick" />
                <p className="common_para lh_25 mb-0 pe-xl-3">
                  If someone does not have sufficient time available for canying out 52 malas japa at a stretch, he may do so by carrying out 26 malas japa in the morning and 26 malas japa in the evening. It has often been found that even one purashcharana japa helps to remove number of obstacles of daily life, provides comfort in mental anguish and diseases, and brings peace and happiness and prosperity in daily life.
                </p>
              </div>
              <div className="d-flex gap-2 mb-md-3 mb-2">
                <img src={orangeTick} className="mb-auto mt-1" alt="tick" />
                <p className="common_para lh_25 mb-0 pe-xl-3">
                  You are requested to read the literature published by the Ashram for knowing the complete details. Poojya Maharishi Shri has now permitted opening centers for carrying out chanting cum-meditation at every place so that the residents of other villages, towns and even the foreign countries may avail the benefits of meditation through chanting of this benedictoiy Maha Mantra. Regular programs of chanting, meditation and satsanga are carried out at all these centers. Addresses and other details of these centers can be made available from the Ashram through correspondence.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isModalOpen && (
        <div
          className="nav_overlay position-fixed top-0 start-0 vh-100 w-100 z_index_4"
          onClick={() => setPopupOpen(null)}
        ></div>
      )}
      {isModalOpen && (
        <Modal
          data={ModalList[popupOpen]}
          showPopup={() => setPopupOpen(null)}
        />
      )}
    </>
  );
};

export default TheGreatSage;
